
export default function EquipmentImagesDeleteModalController($scope, $uibModalInstance) {
    'ngInject';

    $scope.ok = function () {
        $uibModalInstance.close('ok');
    };

    $scope.cancel = function () {
        $uibModalInstance.close('cancel');
    };
}
